import * as React from 'react';
import Checkmark from '@clearkit/icons/glyphs/Checkmark';
import cx from 'classnames';

export interface CKAttributeSelectorItemProps {
  isHighlighted?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  isIndented?: boolean;
  accessoryRenderer?: React.ReactNode;
  attributeMetaRenderer?: React.ReactNode;
  onClick?: () => void;
}

export const CKAttributeSelectorItem: React.FC<CKAttributeSelectorItemProps> = React.forwardRef(
  (
    {
      children,
      isHighlighted,
      isSelected,
      isDisabled,
      attributeMetaRenderer,
      accessoryRenderer,
      isIndented,
      ...rest
    },
    ref: React.Ref<HTMLLIElement>
  ) => {
    const listItemClass = cx('ck-option-item', {
      'ck-option-item--highlighted': isHighlighted,
      'ck-option-item--selected': isSelected && !isHighlighted,
      'text-gray-400': isDisabled && !isHighlighted,
    });

    return (
      <li className={listItemClass} {...rest} ref={ref}>
        {isSelected && <Checkmark className="ck-option-item-accessory" />}
        {accessoryRenderer && (
          <span
            className={cx('w-4 mr-2 pointer-events-none', {
              'ml-12': isIndented,
            })}
          >
            {accessoryRenderer}
          </span>
        )}
        <span className="ck-option-value select-none">{children}</span>
        {attributeMetaRenderer && (
          <span className="ck-option-item-meta select-none">
            {attributeMetaRenderer}
          </span>
        )}
      </li>
    );
  }
);
